<template lang="html">
  <tr>
    <td class="column-id link" @click="go_to_candidate">
      {{ model.id }}
    </td>

    <td class="column-date link" @click="go_to_candidate">
      {{ createdAt }}
    </td>

    <td class="column-name link" @click="go_to_candidate">
      {{ candidate_name }}<br/>
      {{ model.candidate.email }}<br/>
      {{ model.candidate.phone }}
    </td>

    <td class="column-company">
        <a :href="companyHref">{{ model.company.name }}</a>
    </td>

    <td class="column-vacancy">
        <a :href="vacancyHref">{{ model.vacancy.name }} ({{ model.vacancy.id }})</a>
    </td>

    <td class="column-status link" @click="go_to_candidate">
      {{ model.status.name }}
    </td>

    <td class="column-stage link" @click="go_to_candidate">
      {{ model.stage.name }}
    </td>

    <td class="column-questions">
      <template v-for="partition in model.video_partitions">

        <a class="question-progress-bar" :title="partition.description" v-if="partition.take_number > 0">&#11035;</a>
        <a class="question-progress-bar" :title="partition.description" v-else>&#11036;</a>

      </template>
    </td>

  </tr>
</template>

<script>
  import { STORE_PREFIX } from '../constants.js';

  import Moment from 'moment'

  export default {
    name: 'candidate-row',

    components: {},

    props: {
      model: Object
    },

    methods: {
      auth () {
        if (!this.user) {
          throw Error
        }

        this.$store.dispatch(STORE_PREFIX + 'admin/authUser', this.user)
          // .then(() => this.$router.replace('/'))
          .then(() => { window.location = '/' })
      },

      go_to_candidate() {
        this.$router.push({
          path: `/admin/company/1/candidate/${this.model.id}`
        })
      }
    },

    computed: {
      createdAt () {
        return this.model.created_at
          ? Moment(this.model.created_at).format(this.dateFormat)
          : null
      },
      vacancyHref () {
        return '/admin/vacancies/' + this.model.vacancy.id
      },
      companyHref () {
        return '/admin/companies/' + this.model.company.id
      },
      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      },
      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      },
      candidate_name() {
        if (!this.model || !this.model.candidate) {
          return ''
        }

        return !this.is_japan_locale ? `${this.model.candidate.first_name} ${this.model.candidate.last_name}` : `${this.model.candidate.last_name} ${this.model.candidate.first_name}`
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.column-questions {
  font-size: 12px;
}

.question-progress-bar {
  color: $green;
}

.link {
  cursor: pointer;
}
</style>
